import Vue from "vue";
import { createApp, defineComponent, nextTick } from "vue";

//Vue.config.productionTip = false

import VueAxios from "vue-axios";
import axios from "./plugins/axios";
Vue.use(VueAxios, axios);

import { i18n } from "./plugins/i18n";
Vue.use(i18n);

// AnimXYZ
import VueAnimXYZ from "@animxyz/vue";
import "@animxyz/core"; // Import css here if you haven't elsewhere

Vue.use(VueAnimXYZ);
// Mobile detect
import { isMobile as detectMobile } from "mobile-device-detect";

import VueObserveVisibility from "vue-observe-visibility";
Vue.use(VueObserveVisibility);

/* import FsLightbox from 'fslightbox-vue'
Vue.component( 'light-box', FsLightbox )  */

// Components
import Hero from "./components/Hero";
import ImageColorBlockTextCta from "./components/ImageColorBlockTextCta";
import MasterplanMap from "./components/MasterplanMap";
import CardsSlider from "./components/CardsSlider";
import CardsSliderToggle from "./components/CardsSliderToggle";
import TwoCardsText from "./components/TwoCardsText";
import BigImageSlider from "./components/BigImageSlider";
import PopOutImageTextCta from "./components/PopOutImageTextCta";
import SidePaddedImageSlider from "./components/SidePaddedImageSlider";
import FormBlock from "./components/FormBlock";
import ExploreCards from "./components/ExploreCards";
import SimpleTextBlock from "./components/SimpleTextBlock";
import FlightMap from "./components/FlightMap";
import TextSwitchingTabsIcons from "./components/TextSwitchingTabsIcons";
import TimelineCards from "./components/TimelineCards";
import InfoBar from "./components/InfoBar";
import ImageTextCtaIcons from "./components/ImageTextCtaIcons";
import Calendar from "./components/Calendar";
import SingleEvent from "./components/SingleEvent";
import ActivitiesList from "./components/ActivitiesList";
import ToponymsList from "./components/ToponymsList";
import StoresList from "./components/StoresList";
import CtaBar from "./components/CtaBar";
import ImageSideCard from "./components/ImageSideCard";
import TextIcons from "./components/TextIcons";
import HeroProperty from "./components/HeroProperty";
import Floorplan from "./components/Floorplan";
import PropertiesList from "./components/PropertiesList";
import ThreeCardsText from "./components/ThreeCardsText";
import ProgressRing from "./components/ProgressRing";
import PartnerCards from "./components/PartnerCards";
import TeamCards from "./components/TeamCards";
import FullMasterplanMap from "./components/FullMasterplanMap";
import Downloads from "./components/Downloads";
import NewsBlogList from "./components/NewsBlogList";
import HeroDefaultPost from "./components/HeroDefaultPost";
import ReadNextDefaultPost from "./components/ReadNextDefaultPost";
import ToponymsMap from "./components/ToponymsMap";
import StoresMap from "./components/StoresMap";
import MarinaMap from "./components/MarinaMap";
import BasicMap from "./components/BasicMap";
import PortfolioMap from "./components/PortfolioMap";
import SimpleImageBlock from "./components/SimpleImageBlock";
import Contact from "./components/Contact";
import MappedImage from "./components/MappedImage";
import ThankYou from "./components/ThankYou";
import CountUpNumber from "./components/CountUpNumber";

Vue.component("hero", Hero);
Vue.component("image-color-block-text-cta", ImageColorBlockTextCta);
Vue.component("masterplan-map", MasterplanMap);
Vue.component("cards-slider", CardsSlider);
Vue.component("cards-slider-toggle", CardsSliderToggle);
Vue.component("two-cards-text", TwoCardsText);
Vue.component("big-image-slider", BigImageSlider);
Vue.component("pop-out-image-text-cta", PopOutImageTextCta);
Vue.component("side-padded-image-slider", SidePaddedImageSlider);
Vue.component("form-block", FormBlock);
Vue.component("explore-cards", ExploreCards);
Vue.component("simple-text-block", SimpleTextBlock);
Vue.component("flight-map", FlightMap);
Vue.component("text-switching-tabs-icons", TextSwitchingTabsIcons);
Vue.component("timeline-cards", TimelineCards);
Vue.component("info-bar", InfoBar);
Vue.component("image-text-cta-icons", ImageTextCtaIcons);
Vue.component("calendar", Calendar);
Vue.component("activities-list", ActivitiesList);
Vue.component("toponyms-list", ToponymsList);
Vue.component("stores-list", StoresList);
Vue.component("single-event", SingleEvent);
Vue.component("cta-bar", CtaBar);
Vue.component("image-side-card", ImageSideCard);
Vue.component("text-icons", TextIcons);
Vue.component("hero-property", HeroProperty);
Vue.component("floorplan", Floorplan);
Vue.component("properties-list", PropertiesList);
Vue.component("three-cards-text", ThreeCardsText);
Vue.component("progress-ring", ProgressRing);
Vue.component("partner-cards", PartnerCards);
Vue.component("team-cards", TeamCards);
Vue.component("full-masterplan-map", FullMasterplanMap);
Vue.component("downloads", Downloads);
Vue.component("news-blog-list", NewsBlogList);
Vue.component("hero-default-post", HeroDefaultPost);
Vue.component("read-next-default-post", ReadNextDefaultPost);
Vue.component("toponyms-map", ToponymsMap);
Vue.component("stores-map", StoresMap);
Vue.component("marina-map", MarinaMap);
Vue.component("basic-map", BasicMap);
Vue.component("portfolio-map", PortfolioMap);
Vue.component("simple-image-block", SimpleImageBlock);
Vue.component("contact", Contact);
Vue.component("mapped-image", MappedImage);
Vue.component("thank-you", ThankYou);
Vue.component("count-up-number", CountUpNumber);

import locomotiveScroll from "locomotive-scroll";
import "locomotive-scroll/dist/locomotive-scroll.css";

Vue.config.devtools = true;

//mixin used to implement methods needed to parse data passed from acf
Vue.mixin({
	props: {
		block_id: String,
		inner: String,
	},
	data() {
		return {
			blockData: false,
			fieldsData: false,
			optionsData: false,
			templateData: false,
			endpoints: false,
			archiveData: false,
			postData: false,
			/* locationsData: false, */
			neighbourhoodsData: false,
			isMobile: false,
			currentLanguage: false,
		};
	},
	created() {
		//mount gutenberg block data if present
		if (typeof window.blocks_data !== "undefined") {
			this.blockData = window.blocks_data[this.$props.block_id];
		}
		//mount acf fields data if present
		if (typeof window.fields_data !== "undefined") {
			this.fieldsData = window.fields_data;
		}
		//mount options acf fields data if present
		if (typeof window.options_data !== "undefined") {
			this.optionsData = window.options_data;
		}
		//mount template data if present
		if (typeof window.page_template !== "undefined") {
			this.templateData = window.page_template;
		}
		//mount endpoints data if present
		if (typeof window.endpoints !== "undefined") {
			this.endpoints = window.endpoints;
		}
		//mount archivetaxonomy data if present
		if (typeof window.archive_taxonomy !== "undefined") {
			this.archiveData = window.archive_taxonomy;
		}
		//mount archivetaxonomy data if present
		if (typeof window.post_data !== "undefined") {
			this.postData = window.post_data;
		}
		//mount locations taxonomy data if present
		/* if ( typeof( window.locations_taxonomy_data) !== 'undefined' ) {
            this.locationsData = window.locations_taxonomy_data
        } */
		//mount locations taxonomy data if present
		if (typeof window.neighbourhoods_taxonomy_data !== "undefined") {
			this.neighbourhoodsData = window.neighbourhoods_taxonomy_data;
		}
		// detect mobile
		this.isMobile = detectMobile;

		if (typeof window.current_language !== "undefined") {
			this.currentLanguage = window.current_language;
		}
	},
	methods: {
		__(term) {
			let translation = this.$i18n.t(term);
			if (typeof translation === "undefined" || translation == "") {
				return term;
			}
			return translation;
		},
	},
});

new Vue({
	i18n,
	el: "#wrapper",
	data() {
		return {
			isMobile: false,
			scroll: false,
			isDropdownActive: false,
			showPreloader: true,
			srcollReady: false,
		};
	},
	created() {
		/* window.addEventListener('scroll', this.handleScroll) */
		this.isMobile = detectMobile;
	},
	mounted() {
		// Preloader
		window.addEventListener("load", (event) => {
			this.preloaderLoaded();

			// on field focus stop lokomotive - selected-flag
			let formEl = document.querySelectorAll(".form-control .selected-flag");
			let formCountry = document.querySelectorAll(
				".form-control .country-select"
			);

			formCountry.forEach((el) => {
				this.addScrollStopListeners(el);
			});
			formEl.forEach((el) => {
				this.addScrollStopListeners(el);
			});

			// shopmap on focus stop lokomotive
			let openShops = document.querySelectorAll(".openShops");
			// let openShops = document.querySelectorAll('.sidebar');
			openShops.forEach((el) => {
				// this.addScrollStopListeners(el)
				el.addEventListener("focus", (e) => {
					this.scroll.stop();
				});
				el.addEventListener("blur", (e) => {
					this.scroll.start();
				});
			});
		});

		this.$i18n.setLocaleMessage(
			window.current_language,
			window.translations_data
		);
		this.$i18n.locale = window.current_language;

		new ResizeObserver(this.resizeObserverCallback).observe(
			document.getElementById("wrapper")
		);

		let header = document.querySelector("#header");
		this.menuIconChange();
		this.$nextTick(() => {
			this.scroll = new locomotiveScroll({
				el: document.querySelector("[data-scroll-container]"),
				smooth: true,
				lerp: 0.05,
				offset: [0, "50%"],
			});

			/*setTimeout(() => {
                this.scroll.update()
            }, 2000);*/

			this.srcollReady = true;

			this.scroll.on("scroll", (args) => {
				if (args.scroll.y > 50 && !header.className.includes("header-change")) {
					header.classList.add("header-change");
				} else if (args.scroll.y < 50) {
					header.classList.remove("header-change");
				}
			});
		});
		this.menuIconChange();
		this.overrideHashScroll();

		document.querySelectorAll(".wpcf7").forEach((el) => {
			var submitButton = el.querySelector('input[type="submit"]');
			el.addEventListener("submit", (e) => {
				submitButton.disabled = true;
			});
			el.addEventListener(
				"wpcf7submit",
				(e) => {
					//submitButton.disabled = false
				},
				false
			);
		});
	},
	destroyed() {},
	methods: {
		addScrollStopListeners(el) {
			el.addEventListener("focus", (e) => {
				this.scroll.stop();
			});
			el.addEventListener("blur", (e) => {
				this.scroll.start();
			});
		},
		preloaderLoaded() {
			if (this.srcollReady) {
				this.showPreloader = false;
				document.body.classList.remove("preloader-site");
			}
		},
		toggleHamburger: function () {
			this.isDropdownActive = !this.isDropdownActive;
			this.closeAllMenuItems();

			if (this.isDropdownActive) {
				document.body.classList.add("no-scroll");
				document.documentElement.classList.add("no-scroll");

				if (this.scroll && typeof this.scroll.stop === "function") {
					this.scroll.stop();
				}
			} else {
				document.body.classList.remove("no-scroll");
				document.documentElement.classList.remove("no-scroll");

				if (this.scroll && typeof this.scroll.start === "function") {
					this.scroll.start();
				}
			}
		},

		closeAllMenuItems() {
			let menuparents = document.querySelectorAll(
				".btm-nav__wrap--mobile ul.menu-wrapper > li.menu-item-has-children > a.flip"
			);
			menuparents.forEach((el) => {
				el.classList.toggle("flip");
				el.nextElementSibling.classList.toggle("block");
			});
		},
		menuIconChange() {
			let menuLinkIcon = document.querySelectorAll(
				".btm-nav__wrap--mobile ul.menu-wrapper > li.menu-item-has-children > a"
			);
			menuLinkIcon.forEach((el) => {
				el.onclick = (e) => {
					e.preventDefault();
					el.classList.toggle("flip");
					el.nextElementSibling.classList.toggle("block");
				};
			});
		},
		resizeObserverCallback() {
			this.scroll.update();
		},
		overrideHashScroll() {
			document.querySelectorAll('a[href^="#"]').forEach((el) => {
				el.addEventListener("click", (e) => {
					if (el.getAttribute("href") !== "#") {
						e.preventDefault();
						let target = document.getElementById(
							el.getAttribute("href").replace("#", "")
						);
						this.scroll.scrollTo(target);
					}
				});
			});
		},
	},
});
